import { useEffect } from "react";
import { Box, Button, Grid, Typography, useMediaQuery, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { InactivityHandler } from "@components/InactivityHandler";
import { RootState, useAppDispatch } from "@store/store";
import { useSelector } from "react-redux";
import CustomRightImage from "@components/CustomRightImagev2";
import icon from "@assets/img/icon_validando_expediente.svg";
import useInterval from "@hooks/useInterval";
import { useLazyGetLoanApplicationByIdQuery } from "@api/applications";
import { setLoanStatus } from "@store/slices/registerSlice";
import { STATUS_CATALOG } from "@helpers/constantes";

const SECONDS_TO_FETCH = 120;

const ValidandoExpedientePF: React.FC = () => {
  // hooks
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down("md"));
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  // redux hooks
  const application = useSelector((state: RootState) => state.register.application);

  // api hooks
  const [getLoanApplicationById] = useLazyGetLoanApplicationByIdQuery();

  const loanInterval = useInterval(async () => {
    try {
      const loan_application = await getLoanApplicationById(application.id).unwrap();
      if (loan_application.status_catalog?.code !== STATUS_CATALOG.errores_expediente_pf.code) {
        if (loan_application.status_catalog?.code && loan_application.status_catalog?.url_actual) {
          dispatch(setLoanStatus(loan_application.status_catalog?.code));
          navigate(loan_application.status_catalog?.url_actual);
        }
      }
    } catch (error) {
      console.error("Ha ocurrido un error al obtener la aplicación");
    }
  }, SECONDS_TO_FETCH);

  useEffect(() => {
    loanInterval.setIsActiveInterval(true);

    return () => {
      loanInterval.setIsActiveInterval(false);
    };
  }, [loanInterval]);

  return (
    <Grid container height="100%">
      <Grid item xs={12} md={8} mt={2}>
        <InactivityHandler />
        <Box textAlign={"center"} mx={4}>
          <Typography mt={4} mb={3} fontSize={"20px"} fontWeight={600} color={theme?.palette?.primary?.dark}>
            Faltantes en Expediente
          </Typography>

          <Box sx={{ paddingTop: "2em" }}>
            <Typography fontWeight={300} color={theme?.palette?.primary?.dark} fontSize={"16px"}>
              Encontramos faltantes dentro de la validación.
            </Typography>
          </Box>

          <Box sx={{ paddingTop: "3em" }}>
            <img src={icon} alt="icon" />
          </Box>

          <Box sx={{ paddingTop: "2em", paddingBottom: "1em" }}>
            <Typography fontWeight={300} color={theme?.palette?.primary?.dark} fontSize={"16px"}>
              Podría ser necesario el editar algunas secciones o volver a cargar algunos documentos.
            </Typography>
          </Box>

          <Grid container columnSpacing={1} my={4} justifyContent="center">
            <Grid item xs={6} sm={4} md={3}>
              <Button
                variant="default"
                type="submit"
                size="medium"
                fullWidth
                onClick={() => navigate("/producto/creditosimple/expediente_pf")}
                sx={{ mt: 2, padding: "12px", backgroundColor: "#F2704F" }}
              >
                Volver a llenar
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Grid>
      {!isMobileOrTablet && (
        <Grid item xs={12} md={4}>
          <CustomRightImage />
        </Grid>
      )}
    </Grid>
  );
};

export default ValidandoExpedientePF;
